import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { IContact } from "src/app/models/contact/contact";

@Component({
  selector: "app-contact-form",
  templateUrl: "./contact-form.component.html",
  styleUrls: ["./contact-form.component.scss"],
})
export class ContactFormComponent implements OnChanges {
  @Input() contact: IContact | null = null;

  @Output() submit = new EventEmitter<IContact>();

  form = new UntypedFormGroup({
    faxNumber: new UntypedFormControl("", [
      Validators.required,
      Validators.pattern("[+]{1}[0-9]{1,3}[0-9]{10}"),
    ]),
    name: new UntypedFormControl("", [Validators.required, Validators.pattern("[a-zA-Z.-\\D]{2,60}")]),
    email: new UntypedFormControl("", Validators.email),
  });

  onSubmit() {
    if (this.form.valid) {
      this.submit.emit(this.form.value);
    }
  }

  ngOnChanges() {
    if (this.contact !== null) {
      this.form.get("faxNumber").setValue(this.contact.faxNumber);
      this.form.get("name").setValue(this.contact.name);
      this.form.get("email").setValue(this.contact.email);
    }
  }
}
